var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _c('div', {
    staticClass: "page__button"
  }, [_c('div', [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 關閉 ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }